// extracted by mini-css-extract-plugin
export default {"textbox":"styles_textbox__G02AC"};